import { createSelector } from 'reselect'
import { PAPER_VENDOR_TYPE, DIGITAL_VENDOR_TYPE } from 'Constants'

export const getGlCodes = ({ glCode }) => glCode.records
export const getExpenseCategories = ({ expenseCategory }) => expenseCategory.records
export const getVendors = ({ vendor }) => vendor.records

const getVendorAddingAlias = ({ vendor }) => vendor.addingAlias
const getVendorAddingTag = ({ vendor }) => vendor.addingTag
const getVendorAliases = ({ vendor }) => vendor.aliases
const getVendorChangingAlias = ({ vendor }) => vendor.changingAlias
const getVendorChangingTag = ({ vendor }) => vendor.changingTag
const getCreatingVendor = ({ searchVendor }) => searchVendor.creating

export const getVendorByType = ({ vendor }) =>
  vendor.records.reduce(
    (acc, { id, type }) => {
      acc[type].push(id)
      return acc
    },
    {
      [PAPER_VENDOR_TYPE]: [],
      [DIGITAL_VENDOR_TYPE]: [],
    },
  )

const vendorSelectors = {
  getVendorAddingAlias: createSelector([getVendorAddingAlias], (addingAlias) => {
    return addingAlias
  }),
  getVendorAddingTag: createSelector([getVendorAddingTag], (addingTag) => {
    return addingTag
  }),
  getVendorAliases: (sortByName) =>
    createSelector([getVendorAliases], (aliases) => {
      if (!aliases.length) {
        return []
      }
      if (sortByName) {
        aliases = aliases.sort((alias1, alias2) => {
          const name1 = alias1.value.name
          const name2 = alias2.value.name
          if (name1 > name2) {
            return 1
          }
          if (name1 < name2) {
            return -1
          }
          return 0
        })
      }
      return aliases
    }),
  getVendorChangingAlias: createSelector([getVendorChangingAlias], (changingAlias) => {
    return changingAlias
  }),
  getVendorChangingTag: createSelector([getVendorChangingTag], (changingTag) => {
    return changingTag
  }),
  getCreatingVendor: createSelector(getCreatingVendor, (creatingVendor) => {
    return creatingVendor
  }),
  getVendors: createSelector([getVendors], (vendors) => {
    return vendors
  }),
  getVendorOptions: createSelector([getVendors], (vendors) => {
    if (!vendors.length) {
      return []
    }

    return vendors.map((vendor) => ({
      label: vendor.name,
      value: vendor,
    }))
  }),
}

export default vendorSelectors
